import { useQuery } from '@apollo/client';
import classNames from 'classnames/bind';
import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import { IBenefit, Route, Unit } from 'common/promotion';
import { IItinerary } from 'common/types';
import { TripType } from 'contexts/searchParams';
import styles from './index.module.scss';
import GET_PROMOTION_BANNER from './promotionBanner.gql';

const cx = classNames.bind(styles);

interface IData {
  promotionTextBanner: { discount: IBenefit; payPoint: IBenefit };
}

interface IProps {
  itinerary: IItinerary[];
  route: Route;
  fareType?: string;
  trip?: TripType;
}

const unitTextMap = new Map([
  [Unit.KRW, '원'],
  [Unit.PERCENT, '%'],
]);

export default function PromotionBanner({
  route,
  trip,
  itinerary,
  fareType,
}: IProps) {
  const { data } = useQuery<IData>(GET_PROMOTION_BANNER, {
    variables: {
      fareType,
      itinerary,
      route,
      trip,
    },
  });
  if (
    !(
      data?.promotionTextBanner?.discount || data?.promotionTextBanner?.payPoint
    )
  ) {
    return null;
  }
  const {
    promotionTextBanner: { discount, payPoint },
  } = data;
  return (
    <div className={cx('PromotionBanner')}>
      <div className={cx('info')}>
        <b className={cx('title')}>
          항공권{' '}
          {discount && (
            <strong className={cx('discount')}>
              <b>{withPriceSeperator(discount.value)}</b>
              {unitTextMap.get(discount.unit)} 할인
            </strong>
          )}
          {discount && payPoint && ` + `}
          {payPoint && (
            <strong className={cx('bonus')}>
              <b>{withPriceSeperator(payPoint.value)}</b>
              {unitTextMap.get(payPoint.unit)} 적립
            </strong>
          )}
        </b>
        <i className={cx('desc')}>- 이벤트 상품 한정</i>
      </div>
    </div>
  );
}
